import { RouteConfig, Route } from 'vue-router';
import { authenticationGuard } from '@app/routes/auth';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import AppStoreModule from '../store/modules/AppStoreModule';
import AppModule from '../types/base/AppModule';

const appStore: AppStoreModule = getStoreModule(AppStoreModule);

export const routes: RouteConfig[] = [
	{
		path: '',
		component: (): any => import('@modules/select/SelectModule.vue'),
		beforeEnter: (to: Route, from: Route, next: (route?: any) => void): void => {
			appStore.setActiveAppModule(AppModule.Select);
			authenticationGuard(to, from, next);
		},
		children: [
			{
				path: '/',
				name: 'select',
				component: (): any => import('@mediators/select/PresentationListViewMediator.vue')
			},
			{
				path: '/select/:id/edit',
				name: 'edit',
				component: (): any => import('@mediators/select/CreateViewMediator.vue')
			},
			{
				path: '/select/create',
				name: 'create',
				component: (): any => import('@mediators/select/CreateViewMediator.vue')
			},
			{
				path: '/select/:idToDuplicate/duplicate',
				name: 'duplicate',
				component: (): any => import('@mediators/select/CreateViewMediator.vue')
			}
		]
	}
];
